import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function PointIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <g transform="translate(2 2)">
                <path d="M9 12.5C9 13.88 11.239 15 14 15C16.761 15 19 13.88 19 12.5M1 7.49999C1 8.87999 3.239 9.99999 6 9.99999C7.126 9.99999 8.165 9.81399 9 9.49999M1 11C1 12.38 3.239 13.5 6 13.5C7.126 13.5 8.164 13.314 9 13M14 11C11.239 11 9 9.87999 9 8.49999C9 7.11999 11.239 5.99999 14 5.99999C16.761 5.99999 19 7.11999 19 8.49999C19 9.87999 16.761 11 14 11Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M1 3.50001V14.5C1 15.88 3.239 17 6 17C7.126 17 8.164 16.814 9 16.5M9 16.5V8.50001M9 16.5C9 17.88 11.239 19 14 19C16.761 19 19 17.88 19 16.5V8.50001M11 6.50001V3.50001" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 6C3.239 6 1 4.88 1 3.5C1 2.12 3.239 1 6 1C8.761 1 11 2.12 11 3.5C11 4.88 8.761 6 6 6Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    );
}

export default PointIcon;
